import React, { useState } from 'react'
import { useTranslate } from 'react-admin'
import * as yup from 'yup'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import ButtonWithLoader from '../../../ui/ButtonWithLoader/ButtonWithLoader'
import useFormValidation from '../../../../hooks/useFormValidation'
import mutationType from '../../../../types/mutationType'
import AddTeamFormBody from './AddTeamFormBody/AddTeamFormBody'
import genderType from '../../../../types/genderType'
import ageRestrictionType from '../../../../types/ageRestrictionType'

const AddTeamForm = (props) => {
  const { gender, ageRestriction, orgId, seasonId, addTeam, updateTeam, teamData, isEditMode } = props
  const initialLogoUrl = teamData?.logoUrl || ''
  const [croppedTeamLogo, setCroppedTeamLogo] = useState(initialLogoUrl)
  const { stringThreeLetters } = useFormValidation()
  const translate = useTranslate()

  // logoDataUri: null = no change, "" = remove, data URI = new upload
  const getLogoDataUri = () => {
    if (croppedTeamLogo === initialLogoUrl) return null
    return croppedTeamLogo || ''
  }

  const handleSubmit = (values) => {
    if (isEditMode && updateTeam) {
      const updatePayload = {
        teamId: teamData.id,
        name: values.name,
        threeLetterIdentifier: values.threeLetterIdentifier,
        gender: values.gender,
        ageRestriction: values.ageRestriction,
        logoDataUri: getLogoDataUri(),
        externalId: values?.externalId,
        color: values?.teamColor?.value || values?.teamColor,
        clubId: teamData.clubId,
      }

      if (seasonId) {
        updatePayload.seasonId = seasonId
      }

      updateTeam.mutate(updatePayload)
    } else {
      const payload = {
        orgId,
        name: values.name,
        threeLetterIdentifier: values.threeLetterIdentifier,
        gender: values.gender,
        ageRestriction: values.ageRestriction,
        logoDataUri: croppedTeamLogo,
        externalId: values?.externalId,
        color: values?.teamColor?.value || values?.teamColor,
      }

      if (seasonId) {
        payload.seasonId = seasonId
      }

      addTeam.mutate(payload)
    }
  }

  return (
    <Formik
      initialValues={{
        name: teamData?.name || '',
        threeLetterIdentifier: teamData?.threeLetterIdentifier || '',
        ageRestriction: teamData?.ageRestriction?.id || teamData?.ageRestriction || '',
        gender: teamData?.gender?.id || teamData?.gender || '',
        externalId: teamData?.externalId || '',
        teamColor: teamData?.color || '',
      }}
      validationSchema={yup.object().shape({
        threeLetterIdentifier: stringThreeLetters,
      })}
      onSubmit={(values) => handleSubmit(values)}
    >
      {({ setFieldValue }) => (
        <Form>
          <AddTeamFormBody
            setFieldValue={setFieldValue}
            gender={gender}
            ageRestriction={ageRestriction}
            setCroppedTeamImage={setCroppedTeamLogo}
            defaultImageSrc={initialLogoUrl}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '5px 10px' }}>
            <ButtonWithLoader
              label={translate(isEditMode ? 'ra.buttons.save' : 'ra.buttons.add')}
              loading={isEditMode ? updateTeam?.isLoading : addTeam?.isLoading}
              justifyContent='flex-end'
            />
          </div>
        </Form>
      )}
    </Formik>
  )
}

AddTeamForm.propTypes = {
  gender: PropTypes.arrayOf(genderType),
  ageRestriction: PropTypes.arrayOf(ageRestrictionType),
  orgId: PropTypes.string,
  seasonId: PropTypes.string,
  addTeam: mutationType,
  updateTeam: mutationType,
  teamData: PropTypes.object,
  isEditMode: PropTypes.bool,
}

AddTeamForm.defaultProps = {
  gender: [],
  ageRestriction: [],
}

export default AddTeamForm
